import { faGear , faCirclePlus , faCircleArrowLeft , faMoneyBills , faCode} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


function MenuButtons() {

  return (
    <>
       <div className='row'>
                    <div className="col-lg-12">
                        <div className="wrap-btn">
                         <Link to="/refprogram" className="tf-button style2 w-100">
                            <FontAwesomeIcon icon={faMoneyBills} style={{marginRight:"5px"}} />Refferal Program 
                         </Link>
                        </div>
                    </div>
                </div>
               
              <div className='row'>
                    <div className="col-lg-6 mt-3">
                        <div className="wrap-btn">
                         <Link to="/" className="tf-button style2 w-100">
                            <FontAwesomeIcon icon={faCirclePlus} style={{marginRight:"5px"}} />Create Token 
                         </Link>
                        </div>
                    </div>
                    <div className="col-lg-6 mt-3">
                    <div className="wrap-btn">
                         <Link to="/create-free-erc20-token" className="tf-button style2 w-100">
                            <FontAwesomeIcon icon={faCode} style={{marginRight:"5px"}} />Create Token Free 
                         </Link>
                        </div>
                    </div>
                </div>


                <div className='row'>
                    <div className="col-lg-12 mt-3">
                    <div className="wrap-btn">
                            <Link to="/tokenmanage" type="submit" className="tf-button style2 w-100">
                                <FontAwesomeIcon icon={faGear} style={{marginRight:"5px"}} />Token Management 
                            </Link>
                        </div>
                    </div>
                </div>
    </>
  );
}

export default MenuButtons;